
const digest = '947ab010068f4e476d5852aaad4c16852cb53f00bb8409401b48f16d0e14e383';
const classes = {"wrapper":"_wrapper_1vs4x_1","root":"_root_1vs4x_8"};
const css = `._wrapper_1vs4x_1 {
  height: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
}

._root_1vs4x_8 {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: calc(100vh - 120px);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  